<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 5.40881L18.5912 4L12 10.566L5.40881 4L4 5.40881L10.566 12L4 18.5912L5.40881 20L12 13.434L18.5912 20L20 18.5912L13.434 12L20 5.40881Z"
      fill="var(--gray600)"
    />
  </svg>
</template>
